import { SiteSurveyUnitAttribute } from "../types/siteSurveyUnitAttribute";
import { Attribute as AttributeType } from "../types/attribute";

export function tryGetAttributeValue(
  attributesConfig: AttributeType[],
  attributes: SiteSurveyUnitAttribute[],
  attributeName: string
): string {
  const { value } = getAttributeConfigAndValue(
    attributesConfig,
    attributes,
    attributeName
  );

  return value?.attributeValue ?? "";
}

export function getAttributeConfigAndValue(
  attributesConfigs: AttributeType[],
  attributes: SiteSurveyUnitAttribute[],
  attributeName: string
): { config: AttributeType; value?: SiteSurveyUnitAttribute } {
  const matchingConfig = attributesConfigs.find(
    (c) => c.text === attributeName
  );

  if (!matchingConfig)
    throw new Error(
      `Can't find attribute config for given attribute Name ${attributeName}`
    );

  const matchingAttributeValue = attributes.find(
    (a) => a.attributeId === matchingConfig.id
  );

  return { config: matchingConfig, value: matchingAttributeValue };
}
